/* eslint semi: 1 */

import _ from 'lodash';

// this is a way to deal with JIT of TailwindCSS:
// classes should be explicitly mentioned somewhere in the code
// and dynamic naming is not allowed.
export const HeightOptions = {
  medium: ['mt-[90px]', 'min-h-[90px]'],
  short: ['mt-[45px]', 'min-h-[45px]'],
  auto: ['mt-0', ''],
  minimal: ['mt-0', '']
};

export default {
  name: 'player-setup-form-error',
  props: {
    display: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: 'auto',
      validator (value) {
        return !_.isUndefined(HeightOptions[value]);
      }
    }
  },
  computed: {
    outerClasses: function () {
      return _.fromPairs([
        [HeightOptions[this.height][0], !this.display]
      ]);
    },
    innerClasses: function () {
      return _.fromPairs([
        ['pt-5', this.height !== 'minimal'],
        ['pb-8', this.height !== 'minimal'],
        [HeightOptions[this.height][1], this.display]
      ]);
    }
  }
};
